import { intl } from '@beelday/common'
import { RootState } from 'common/redux'
import { ArchivedActivityCard } from 'features/script'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import { ErrorWithStreams } from 'room/common/error-with-streams'
import { UUID } from '../../common/types'
import KnowledgeCheckGridView from './presentation/knowledge-check-grid-view'
import { useTraineeKnowledgeCheck } from './use-trainee-knowledge-check'
import { navigateToRecaps } from 'workflow/navigate-to-recaps'

const ConfiguredKnowledgeCheckTrainee: FC<{ knowledgeCheckId: UUID }> = ({
	knowledgeCheckId,
}) => {
	const { knowledgeCheck, error, reload, onAnswer, onPrev, onNext, onFinish } =
		useTraineeKnowledgeCheck(knowledgeCheckId)

	const training = useSelector((state: RootState) => state.sessionInfo.training)
	const trainerProfile = useSelector(
		(state: RootState) =>
			state.users.all[
				training?.upperEchelon.userId ? training?.upperEchelon.userId : ''
			]
	)

	if (error) {
		return (
			<ErrorWithStreams retry={reload}>
				<intl.Translate>knowledge_check.error.load</intl.Translate>
			</ErrorWithStreams>
		)
	}

	if (!knowledgeCheck) return null

	if (knowledgeCheck.doneInPreviousSession) {
		return (
			<ArchivedActivityCard
				title={knowledgeCheck.name}
				toolType="KNOWLEDGE_CHECK"
				representativeQuestion={knowledgeCheck.questions[0]?.question}
				isTrainer={false}
				onSeeInRecaps={
					training
						? () =>
								navigateToRecaps({ trainingId: training.id, isTrainer: false })
						: undefined
				}
			/>
		)
	}

	return (
		<KnowledgeCheckGridView
			title={training?.subject}
			userProfile={trainerProfile}
			knowledgeCheck={knowledgeCheck}
			onAnswer={onAnswer}
			onPrev={onPrev}
			onNext={onNext}
			onFinish={onFinish}
		/>
	)
}

export default ConfiguredKnowledgeCheckTrainee
